import React from 'react'
import styles from './InputTextarea.less'

export default class InputTextarea extends React.Component {
    render() {
        const {className, ...props} = this.props
        const {inputTextarea: inputTextareaClass} = styles
        const classes = [inputTextareaClass]

        if (className) {
            classes.push(className)
        }

        return (
            <textarea className={classes.join(' ')} {...props} />
        )
    }
}